import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';
import { IKpiTClassBlocks } from '../../../../services-api-v2/kpi-follow-up/models/process-events-and-t-class-blocks.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { TimezoneService } from 'app/shared/services/timezone/timezone.service';

@Component({
    selector: 'app-kpi-t-class-blocks-list-table',
    templateUrl: './kpi-t-class-blocks-list-table.component.html',
    styleUrls: ['./kpi-t-class-blocks-list-table.component.scss'],
    standalone: false
})
export class KpiTClassBlocksListTableComponent implements OnChanges {

  @Input() tClassBlocks: IKpiTClassBlocks[];
  @Input() displayActionColumn: boolean;
  @Input() isProcessUnassigning: boolean;
  @Output() optionSelected: EventEmitter<any> = new EventEmitter();
  @ViewChild('sort', { static: false }) sort: MatSort;

  public dataSource: MatTableDataSource<IKpiTClassBlocks> = new MatTableDataSource<IKpiTClassBlocks>([]);
  public columnsToDisplay: string[] = [
    'parkName', 'turbineName', 'tcu', 'log', 'startTS', 'endTS', 'duration', 'totalProductionLoss', 'totalRevenueLoss', 'userComment'
  ];
  public columnsToTranslate: string[] = [
    'KPI.PORTFOLIO.T_CLASS_BLOCKS_TABLE.PARK',
    'KPI.PORTFOLIO.T_CLASS_BLOCKS_TABLE.TURBINE',
    'KPI.PORTFOLIO.T_CLASS_BLOCKS_TABLE.T_CLASS',
    'KPI.PORTFOLIO.T_CLASS_BLOCKS_TABLE.TURBINE_LOG',
    'KPI.PORTFOLIO.T_CLASS_BLOCKS_TABLE.START_TIME',
    'KPI.PORTFOLIO.T_CLASS_BLOCKS_TABLE.END_TIME',
    'KPI.PORTFOLIO.T_CLASS_BLOCKS_TABLE.DURATION_REALIZED',
    'KPI.PORTFOLIO.T_CLASS_BLOCKS_TABLE.PROD_LOSS_REALIZED',
    'KPI.PORTFOLIO.T_CLASS_BLOCKS_TABLE.REV_LOSS_REALIZED',
    'KPI.PORTFOLIO.T_CLASS_BLOCKS_TABLE.USER_COMMENT',
  ];
  public optionsSelect = [
    'KPI.PORTFOLIO.PLANNED_EVENTS_TABLE.VIEW_ON_LOGBOOK',
    'KPI.PORTFOLIO.PLANNED_EVENTS_TABLE.UNASSIGN_FROM_PROCESS'
  ];

  constructor(
    public tz: TimezoneService
  ) {}

  ngOnChanges(changes: SimpleChanges) { 
    if (changes.tClassBlocks && changes.tClassBlocks.currentValue) {
      this.dataSource = new MatTableDataSource(changes.tClassBlocks.currentValue);
      this.dataSource.sort = this.sort;
    }

    if (this.displayActionColumn) {
      if (this.columnsToDisplay.indexOf('actions') === -1) {
        this.columnsToDisplay.push('actions');
        this.columnsToTranslate.push('') // EMPTY FOR ACTIONS
      }
    }
  }

	private compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

   public sortData(sort: Sort) {
    const data = this.dataSource.data.slice();
    if (!sort.active || sort.direction === '') {
      return;
    }
    this.dataSource.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      if (sort.active) {
        return this.compare(a[sort.active], b[sort.active], isAsc)
      }
      return 0;
    });
  }

  public selectOption(data, element): void {
    this.optionSelected.emit({data, element})
  }
}
